import React from 'react';

interface ZuneloMarkProps {
  size: number;
  title: string;
}

/** Authentic Zunelo isotipo: three bars with circular terminals (not a letter Z). */
export const ZuneloMark: React.FC<ZuneloMarkProps> = ({ size, title }) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    role="img"
    aria-label={title}
    style={{ display: 'block' }}
  >
    <rect width="32" height="32" rx="7" fill="var(--z-surface)" />
    <g fill="var(--z-text)">
      <rect x="6.6" y="9.1" width="18.8" height="2.2" rx="1.1" />
      <circle cx="6.6" cy="10.2" r="1.7" />
      <circle cx="25.4" cy="10.2" r="1.7" />
      <rect x="11.5" y="14.9" width="9" height="2.2" rx="1.1" />
      <circle cx="11.5" cy="16" r="1.7" />
      <circle cx="20.5" cy="16" r="1.7" />
      <rect x="6.6" y="20.7" width="18.8" height="2.2" rx="1.1" />
      <circle cx="6.6" cy="21.8" r="1.7" />
      <circle cx="25.4" cy="21.8" r="1.7" />
    </g>
  </svg>
);
